import React from 'react'
import { Link } from 'gatsby'
import './styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'

class MobileNavbar extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { showMenu, toggleMenu } = this.props
    return (
      <div className={`mobile-navbar ${showMenu ? 'open' : ''}`}>
        <div className="mobile-navbar-inner">
          <button onClick={() => toggleMenu()} className="close-button">
            x
          </button>
          <Link id="home" className="menu-item" to="/" onClick={() => toggleMenu()}>
            HOME
          </Link>
          <Link id="shop" className="menu-item" to="/shop" onClick={() => toggleMenu()}>
            SHOP
          </Link>
          <Link to="/lookbook" className="menu-item" onClick={() => toggleMenu()}>
            LOOKBOOK
          </Link>
          <Link id="bio" className="menu-item" to="/about" onClick={() => toggleMenu()}>
            ABOUT
          </Link>
          <Link id="contact" className="menu-item" to="/contact" onClick={() => toggleMenu()}>
            CONTACT
          </Link>
          {/* <div className="mobile-social-icons">
            <a
              href="https://www.instagram.com/nsjpa/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="visit nsüpa's instagram profile"
            >
              <FontAwesomeIcon icon={faInstagram} className="icon mobile-social-icon" />
            </a>
            <a
              href="https://twitter.com/nsjpa"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="visit nsüpa's twitter profile"
            >
              <FontAwesomeIcon icon={faTwitter} className="icon mobile-social-icon" />
            </a>
          </div> */}
        </div>
      </div>
    )
  }
}

export default MobileNavbar
